import * as StatisticsActions from './statistics.actions';

export default StatisticsActions;
